import { InitState } from "@/types";
import { createSlice } from "@reduxjs/toolkit";
import { initApp, updateInterest, updateSources } from "./initThunks";

// Initial state
const initialState: InitState = {
  source: [],
  topics: [],
  allSubjects: [],
  allSubSubjects: [],
  allPublishers: [],
  allBooks: [],
  allChapters: [],
  subjectMap: {},
  loading: false,
  error: '',
  initialized: false
}

const initSlice = createSlice({
  name: "init",
  initialState,
  reducers: {
    setAppError: (state, action) => {
      state.error = action.payload
    },
  },
  extraReducers: (builder) => {
    // Handle test initialization
    builder
      .addCase(initApp.pending, (state) => {
        state.loading = true
        state.error = ''
      })
      .addCase(initApp.fulfilled, (state, action) => {
        state.loading = false
        state.source = action.payload.source;
        state.topics = action.payload.topics;
        state.allSubjects = action.payload.allSubjects;
        state.allSubSubjects = action.payload.allSubSubjects;
        state.allPublishers = action.payload.allPublishers;
        state.allBooks = action.payload.allBooks;
        state.allChapters = action.payload.allChapters;
        state.subjectMap = action.payload.subjectMap;
        state.initialized = true;
      })
      .addCase(initApp.rejected, (state, action) => {
        state.loading = false
        state.error = action.payload as string
        state.initialized = false
      })
    builder
      .addCase(updateSources.pending, (state) => {
        state.loading = true
        state.error = ''
      })
      .addCase(updateSources.fulfilled, (state, action) => {
        state.loading = false
        state.source = action.payload;
      })
      .addCase(updateSources.rejected, (state, action) => {
        state.loading = false
        state.error = action.payload as string
      })
    builder
      .addCase(updateInterest.pending, (state) => {
        state.loading = true
        state.error = ''
      })
      .addCase(updateInterest.fulfilled, (state, action) => {
        state.loading = false
        state.topics = action.payload;
      })
      .addCase(updateInterest.rejected, (state, action) => {
        state.loading = false
        state.error = action.payload as string
      })
  },
});

export const { setAppError } = initSlice.actions
export default initSlice.reducer
